import mapLinkAccountPage from './linkAccountPage';
import mapRegisterPage from './registerPage';
import mapTermsPage from './termsPage';
import mapCookiePage from './cookiePage';
import mapResponsibleGamblingPage from './responsibleGamblingPage';
import mapSupportPage from './supportPage';
import mapWithdrawPage from './withdrawPage';

const plusMapper = csData => {
  if (!csData) return csData;
  try {
    const { plusRegisterPage, plusLinkAccountPage, plusTermspage, plusCookiepage, plusResponsiblegamblingpage, plusSupportpage, plusWithdrawpage } = csData;
    return {
      registerPage: mapRegisterPage(plusRegisterPage),
      linkAccountPage: mapLinkAccountPage(plusLinkAccountPage),
      termsPage: mapTermsPage(plusTermspage),
      cookiePage: mapCookiePage(plusCookiepage),
      responsibleGamblingPage: mapResponsibleGamblingPage(plusResponsiblegamblingpage),
      supportPage: mapSupportPage(plusSupportpage),
      withdrawPage: mapWithdrawPage(plusWithdrawpage)
    };
  } catch (err) {
    throw new Error(`Could not map data from ContentStack:${err}`);
  }
};

export default plusMapper;
